import { ccwpApi } from "@/services";

// Server's Content-Disposition filename reflects the actual bytes returned (e.g. a generated .xlsx),
// which can differ from a caller-supplied name that was really the original uploaded document's name.
// Backend sends a quoted "filename=" (optionally alongside RFC 5987 "filename*="); this reads the former.
// Requires the backend to expose this header via CORS (WithExposedHeaders), or it won't be readable here.
function getContentDispositionFileName(response: Response): string | undefined {
  const disposition = response?.headers?.get?.("content-disposition");
  const raw = disposition?.match(/filename="?([^;"]+)"?/i)?.[1];
  if (!raw) return undefined;

  // Header value is untrusted input - strip filesystem-invalid characters (path separators,
  // Windows-reserved punctuation, control chars) and Unicode bidi overrides (e.g. U+202E RLO,
  // used to spoof a file's apparent extension in save dialogs) so it can't smuggle a path or
  // alter/truncate/spoof the save-as name in the browser/OS.
  const safe = raw
    .trim()
    .replace(/[/\\:*?"<>|]/g, "_")
    // eslint-disable-next-line no-control-regex -- intentionally stripping control chars from untrusted input
    .replace(/[\x00-\x1f\x7f]/g, "")
    .replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, "");
  return safe || undefined;
}

export const ExportsApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
      exportAdvanceSearch: builder.mutation({
        query: ({url,data,fileName}) => ({
          url,
          body:data,
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          responseHandler: async (response:any) => {
            if (response?.status === 400) {
              return Promise.reject(response);
            }
            if(response?.status === 200){
              const url = URL.createObjectURL(await response.blob());
              const a = document.createElement("a");
              a.href = url;
              a.download = getContentDispositionFileName(response) || fileName || "downloaded_file";
              const downloadControls =
                document.getElementsByClassName("motif-modal-content")[0] ||
                document.body;
              downloadControls.appendChild(a);
              a.click();
              downloadControls.removeChild(a);
              URL.revokeObjectURL(url);
            }
            },
          transformResponse: (response: { results: any[] }) => response,
          cache: "no-cache",
        }),
      }),

      exportDocument: builder.query({
        query: ({url,fileName,...args}) => ({
          url,
          params:{...args},
          method: "GET",
          responseHandler: async (response:any) => {
            if (response?.status === 400) {
              return Promise.reject(response);
            }
            if(response?.status === 200){
              const url = URL.createObjectURL(await response.blob());
              const a = document.createElement("a");
              a.href = url;
              a.download = getContentDispositionFileName(response) || fileName || "downloaded_file";
              const downloadControls =
                document.getElementsByClassName("motif-modal-content")[0] ||
                document.body;
              downloadControls.appendChild(a);
              a.click();
              downloadControls.removeChild(a);
              URL.revokeObjectURL(url);
            }
            },
          transformResponse: (response: { results: any[] }) => response,
          cache: "no-cache",
        }),
      })
  }),
});

export const { 
              useExportAdvanceSearchMutation,
              useLazyExportDocumentQuery
            } = ExportsApi;
